export default __webpack_public_path__ + "static/media/ng2.1f56d1dd.jpg";